import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InlineLoader from 'components/_core/InlineLoader';
import Message from 'components/_core/Message';
import { fetchPosts } from 'redux/actions/blog';

const AllPostsFetcher = (
    {
        children
    }
) => {
    const dispatch = useDispatch();
    const fetched = useSelector(state => state.blogPosts.fetched);
    const error = useSelector(state => state.blogPosts.error);

    useEffect(() => {
        dispatch(fetchPosts());
    }, [dispatch])

    if (error) {
        return (
            <Message heading="Error loading posts" error noIcon small>
                Refresh the page to try again.
            </Message>
        );
    }

    if (!fetched) {
        return <InlineLoader />;
    }

    return children;
};

export default AllPostsFetcher;
